import React from 'react';
import { SHADCN, R, S } from '../theme';

// ── <Card> — Shadcn dark ────────────────────────────────────────────────────
// Surface translucide sur fond dark, 1px border, radius 10 (R.md).
// Tons sémantiques pour KPI / alertes — tinte le fond et le filet.

const TONES = {
  info:    { bg: SHADCN.cardSolid,                     border: SHADCN.border,                           color: SHADCN.cardFg },
  success: { bg: SHADCN.accentSoft,                   border: SHADCN.accentBorder,                     color: SHADCN.success },
  warning: { bg: 'oklch(0.852 0.199 91.936 / 0.08)',  border: 'oklch(0.852 0.199 91.936 / 0.3)',       color: SHADCN.warning },
  error:   { bg: 'oklch(0.577 0.245 27.325 / 0.12)',  border: 'oklch(0.577 0.245 27.325 / 0.4)',       color: SHADCN.error },
  accent:  { bg: SHADCN.accentSoft,                   border: SHADCN.accentBorder,                     color: SHADCN.accent },
};

function resolveTone(name) {
  if (name === 'danger') return TONES.error;
  return TONES[name] || TONES.info;
}

export default function Card({
  children,
  style,
  padded = true,
  tone = 'info',
  as: Tag = 'div',
  ...rest
}) {
  const t = resolveTone(tone);
  return (
    <Tag
      {...rest}
      style={{
        background: t.bg,
        border: `1px solid ${t.border}`,
        color: t.color,
        borderRadius: R.xl,
        padding: padded ? S[5] : 0,
        marginBottom: S[4],
        ...style,
      }}
    >
      {children}
    </Tag>
  );
}
